import React from 'react'
import { Link } from "react-router-dom";
import Header from '../common/Header'

function FreeTrial() {
	return (
		<>
			<Header />
			<section className="section2" id="" data-section="section1">
				<div className="container">
					<div className="caption">
						<div className="add-line">
							{/* <div className="dd-line2">
								<p className="tclr">One small step for crypto, one huge leap for your airdrop!</p>
							</div>
							<div className="dd-line2 dd-line3">
								<div className="">
									<p className="tclr">0x15d8...63c4</p>
								</div>
								<div className="">
									<p className="tclr">Network: Unsupported ▼</p>
								</div>
							</div> */}
						</div>
						<div className="btm-form" style={{ padding: "50px 15px 50px" }}>
							<div className="pb-5">
								<div className="col-md-11 m-auto">
									<h1 className="mb-5 text-center multi-head"><b>MultiTokendrop Free Trial</b></h1>
									<div data-v-90fa70b0="" className="mt-4 pt-2 article-content">
										<p>Want to test Crypto MultiTokendrop before purchasing our service? Well, lucky for you, we are the only MultiTokendrop that offers a free trial. Best of all, you don't need to do anything to activate it.</p>
										<h3>Here's how the free trial works</h3>
										<p>Previously, the free trial worked on a per-token basis only, meaning that if you had a token that had never been airdropped with Crypto MultiTokendrop before, then the free trial would be applied to the token. However, this system was frequently exploited by users who often deployed new tokens on a regular basis. For this reason, we have implemented a new measure. The free trial is applied to both new tokens and also to new users. </p>
										<p>Here's what this means for you. If you have a token that has never been distributed with our MultiTokendrop, and also if you have not used a free trial for any other token or native currency (i.e. ETH, BNB, AVAX, FTM, Matic), then you will automatically qualify for the free trial. If however, you're a new customer and you're airdropping a token that has been previously airdropped with us by another user (this is typically the case for popular tokens such as USDT, BUSD, etc), then you will not qualify for the free trial. Having said that, if you are a new user and you are airdropping ETH, BNB, or any other native currency, then you will always qualify for the free trial.</p>
										<h3>What's included with the free trial?</h3>
										<p>As mentioned in the section above, the free trial is applied to both users and tokens. In each case, the user and the token will have a minimum of 100 trial drops (i.e. 100 transfers) and potentially up to 1,000 trial drops. When either the user trial drops or the token trial drops run out, then the user will be charged a service fee from that point onward. At this point, you may be wondering why there can be 100 to 1,000 trial drops. The reason for this is because it may very well be the case that our system might be able to send your token out to batches of 1,000 addresses at a time. If this is the case, then you will not be charged for the first batch transfer to 1,000 wallet addresses.  You will only be charged after at least 100 transfers have been automated by Crypto MultiTokendrop. </p>
										<p></p>
										<p>If you have any questions regarding the free trial, please do not hesitate to <Link to="/contact-us">contact us</Link>.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}

export default FreeTrial